import React from 'react'
import { useState, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import './classes/UserTab.css';
import './classes/ViewTab.css';
import { configData } from "../config";
import ManageEmailsEdit from './ManageEmailsEdit';
import Loading from './Loading';
import { Helmet } from 'react-helmet';
import SalespersonSidebar from './SalespersonSidebar';

function ViewEmail  ()  {
 
  const [toggle, setToggle] = useState(1);
  
  const [isLoading, setIsLoading] = useState(true);
  const[emailDetails,setEmailDetails] = useState({});
  const[error,setError] = useState({});
  const location  = useLocation();
   const successMessage = location.state?.message; // Access the message
   window.history.replaceState({}, '');
  
  var {id} = useParams();
  const {tab} = useParams();
  
  const loggedin_uid = localStorage.getItem('uid');
  const navigate = useNavigate();

useEffect(() => {
  const timer = setTimeout(() => {
    window.scrollTo(0, 0);
  }, 2000); // 100ms delay (you can change)

  return () => clearTimeout(timer);
}, [location.pathname, tab]);
  const app_url = configData.APP_URL;

  const domain_url = configData.DOMAIN_URL;
 
  
  function updateToggle(tid){
    setToggle(tid);
     if(tid == 2) { 
      navigate("/emails/"+id+"/edit");
    }
  }
  useEffect(() => {
   
    
    retriveemaildetails();
    setTimeout(() => {
    
    if(tab == "edit") {
      setToggle(2);
    }
   if(tab == "view") {
      setToggle(1);
    }
   
      setIsLoading(false);
    }, 2000);
    
  },[tab]);

    async function retriveemaildetails() {
    try {
        const response = await fetch(
        app_url+'emails/getmanageemaildetails?id='+id,
        {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
        }
        )
        const responsedata = await response.json();
        if(responsedata.data.msg === "Success") {
            setEmailDetails(responsedata.data.result);
            
        }
    }catch (err) {
        setError({
            text:"Error in loading Content"
        }); // Catch network errors or errors thrown from !response.ok
      }

  
  }
  
// function linkify(text) {
//   const urlRegex = /(https?:\/\/[^\s]+)/g;

//   return text.replace(urlRegex, (url) => {
//     return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
//   });
// } 


  // return text.replace(urlRegex, (url) => {
  //   return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  // });

function linkify(text) {
  const urlRegex = /(https?:\/\/[^\s<]+)/g;

return text.replace(urlRegex, (url, _, offset) => {
  const prevChar = text[offset - 1];

  if (prevChar === '"' || prevChar === "'" || prevChar === ">") {
    return url;
  }
  return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
});
} 
// function linkify(text) {
//   const urlRegex = /(https?:\/\/[^\s]+)/g;

//   return text.replace(urlRegex, (url, _, offset) => {
//     // Get the text before the URL (up to 10 chars back to catch </div>, </span>, etc.)
//     const before = text.slice(Math.max(0, offset - 10), offset).toLowerCase();

//     // Check if immediately after a closing tag like </p> or </div>
//     const closingTagMatch = /<\/[a-z]+>$/.test(before);

//     // Also skip if immediately after ", ', or >
//     const prevChar = text[offset - 1];
//     if (prevChar === '"' || prevChar === "'" || prevChar === ">" || closingTagMatch) {
//       return url;
//     }

//     return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
//   });
// }

 
  return (
   <>
   {isLoading ? (
        <Loading />
      ) : (
    <div id="main">
 
      <div class="left"></div>

      <div class="center left-center view-profile-wrapper">
        <Helmet>
          <title>{emailDetails.subject}</title>
        </Helmet> 
    
      <><h2 class="element-invisible">Primary tabs</h2>
      <ul class="tabs primarya">
        <li className= {toggle === 1? "active" : ""} onClick={()=> updateToggle(1)}><a>View<span class="element-invisible">(active tab)</span></a></li>
        <li className= {toggle === 2? "active" : ""} onClick={()=> updateToggle(2)}><a>Edit</a></li>
       
      </ul></>    
      
      <div  className= {toggle === 1? "show-content" : "content"}>
        
         {error.length > 0 && (
          <div className="set-message-error">
           {error.map((item, index) => {
           return <>{item}<br /></>
          
        })}  
          </div>
        )}
         {successMessage && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successMessage}
                        </div>
                        )}
        
          <div className="view-email-content">
           {emailDetails.body && (
          <><strong>Body:</strong><p dangerouslySetInnerHTML={{__html: linkify(emailDetails.body)}}></p></>
          
         )}
          </div>
      
         
      </div>
      <div  className= {toggle === 2? "show-content" : "content"}>
        <ManageEmailsEdit id={id} />
      </div>
     

    </div>

    


<div class="right">
<SalespersonSidebar/>

</div>
  <div class="clear"></div> 
  
</div>
)}
    </>
    
    
  )
}

export default ViewEmail